import React from 'react';
import { Styled } from './';
import { useI18n } from 'contexts/i18n';
import { useDoctorProfile } from 'reactQuery/queries';
import { interpolateString } from 'utils/stringUtils';

const ServicePlanTerm: React.FC<{
  servicePlanFee: string | undefined;
}> = ({ servicePlanFee = '' }) => {
  const { data: doctor } = useDoctorProfile();
  const i18n = useI18n();
  return (
    <Styled.ServicePlanTermWrapper>
      <div>
        <i>
          {i18n['iTero Service Plan Details - Footer note 1 - US']}{' '}
          <a
            href={'https://itero.com/rpa-na'}
            target={'_blank'}
            rel="noreferrer"
          >
            https://itero.com/rpa-na
          </a>
        </i>
      </div>
      <div>
        <i>
          {doctor?.country === 'CA'
            ? interpolateString(
                i18n['iTero Service Plan Details - Footer note 2 - CA'],
                { DYNAMIC_SERVICE_PLAN_FEE: servicePlanFee }
              )
            : interpolateString(
                i18n['iTero Service Plan Details - Footer note 2 - US'],
                { DYNAMIC_SERVICE_PLAN_FEE: servicePlanFee }
              )}
        </i>
      </div>
    </Styled.ServicePlanTermWrapper>
  );
};

export default ServicePlanTerm;
